import { CircleNotch } from "@phosphor-icons/react"

interface PatientEmptyProps extends React.ComponentPropsWithoutRef<"div"> {
  title: string
  message: string
  isLoading?: boolean
}

// When a record is empty
const PatientEmpty = ({ title, message, children, isLoading }: PatientEmptyProps) => {
  return (
    <div className="animate-fade-in-bottom grid h-full content-center items-center justify-center gap-4 p-3 text-center">
      {isLoading ? (
        <CircleNotch className="text-on-surface-subdued h-8 w-8 animate-spin" />
      ) : (
        <>
          <div className="grid gap-1">
            <h2 className="text-on-surface text-xl font-bold">{title}</h2>
            <span className="text-on-surface-subdued text-base">{message}</span>
          </div>
          {children}
        </>
      )}
    </div>
  )
}

export default PatientEmpty
